import React from 'react';
import { Grid } from '@material-ui/core';

const WorkMacOS = (props) => {
    const { classes, translations } = props;
    const icon = (
        <svg width="40" height="40" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill="#7485FF" d="M5.24759 0.0463867L4.96886 5.56077L0.184082 14.875L0.834441 0.0463867H5.24759Z" />
            <path
                fill="#7485FF"
                d="M23.1821 14.2475L18.3629 19.4673L13.6578 10.7507V27.7573L11.7996 28.8694L9.70919 27.6646V11.0751L5.06375 19.8795L3.01977 23.7721L0.000244141 22.0112V20.3429L4.64566 11.2605V11.3068L7.47937 5.69974L10.3596 0.0463394H13.1468L18.6284 10.6117L18.3032 0H22.7163L23.1821 14.2475Z"
            />
            <path
                fill="#7485FF"
                d="M29.796 16.0217L27.6992 13.9247C27.6256 13.8512 27.5258 13.8099 27.4217 13.8099C27.3176 13.8099 27.2178 13.8512 27.1442 13.9247L18.9062 22.9998L17.43 21.5237C17.3563 21.4501 17.2565 21.4087 17.1524 21.4087C17.0484 21.4087 16.9485 21.4501 16.8749 21.5237L14.7777 23.6207C14.7042 23.6944 14.6628 23.7942 14.6628 23.8982C14.6628 24.0023 14.7042 24.1021 14.7777 24.1758L18.6165 28.0137C18.6529 28.0501 18.6961 28.0791 18.7438 28.0988C18.7914 28.1185 18.8424 28.1286 18.8939 28.1286C18.8986 28.1286 18.9028 28.126 18.9074 28.126C18.9113 28.126 18.9155 28.1283 18.9196 28.1283C19.0204 28.1283 19.1202 28.09 19.197 28.0134L29.796 16.5768C29.8324 16.5403 29.8614 16.4971 29.8811 16.4495C29.9009 16.4018 29.911 16.3508 29.911 16.2992C29.911 16.2477 29.9009 16.1967 29.8811 16.149C29.8614 16.1014 29.8324 16.0582 29.796 16.0217Z"
            />
        </svg>
    );

    return (
        <>
            <Grid item ms={12} lg={6}>
                <h2>
                    {icon} Work Verifier (macOS T2 & M1/M2){' '}
                    {classes.latestVersionSpan && (
                        <span className={classes.latestVersionSpan}>
                            - {translations['latest_version'] || 'Latest Version'}
                        </span>
                    )}
                </h2>
                <p>
                    {translations['work_verifier_macOS_download_page'] ||
                        'Complete tool for verification and diagnostic of Apple computers with T2 chip and Apple Silicon computers with M1/M2 chip.'}
                </p>
            </Grid>
        </>
    );
};

export default WorkMacOS;
